module.exports = __webpack_public_path__ + "static/media/caffeBanner.3859728e.jpeg";